import React from 'react';
import { Button } from '@xingternal/button';
import styles from './CustomerFeedbackButton.css';
import { FormattedMessage } from 'react-intl';
import { IconComment } from '@xingternal/icons';

const FEEDBACK_LINKS: Record<string, string> = {
  main: 'https://easy-feedback.de/umfrage/1252082/9XA9g6',
  about_us: 'https://easy-feedback.de/umfrage/1253997/jxvLlq',
  contacts: 'https://easy-feedback.de/umfrage/1254137/o8YK94',
  news: 'https://easy-feedback.de/umfrage/1252095/f20Nl4',
  jobs: 'https://easy-feedback.de/umfrage/1254392/oaX7pF',
  employees: 'https://easy-feedback.de/umfrage/1254393/L496tE',
  groups: 'https://easy-feedback.de/umfrage/1365727/l7U113',
};

type Props = {
  module: string;
};

const CustomerFeedBackButton = ({ module }: Props) => {
  if (!FEEDBACK_LINKS[module]) return null;
  return (
    <div className={styles.buttonWrapper}>
      <Button
        variant={'secondary'}
        size={'small'}
        className={styles.button}
        icon={IconComment}
        href={FEEDBACK_LINKS[module]}
        target="_blank"
      >
        <FormattedMessage id="EP_FEEDBACK_BUTTON" />
      </Button>
    </div>
  );
};

export default CustomerFeedBackButton;
